import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { FestivalHero } from "../components/FestivalHero";
import { Marquee } from "../components/Marquee";
import { BundleFeature } from "../components/BundleFeature";
import { Manifesto } from "../components/Manifesto";
import { LifestyleBanner } from "../components/LifestyleBanner";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { CartDrawer } from "../components/CartDrawer";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [location]);

  return (
    <div className="bg-[#0D110D] min-h-screen">
      <Navbar />
      <Hero />
      <FestivalHero />
      <Marquee />
      <BundleFeature />
      <LifestyleBanner />
      <Manifesto />
      <Contact />
      <Footer />
      <CartDrawer />
    </div>
  );
}
